/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const foodMythsEvening = useStore((state) => state.foodMythsEvening);
  const setFoodMythsEvening = useStore((state) => state.setFoodMythsEvening);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.foodMythsEvening.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={foodMythsEvening}
          onChange={(value) => {
            setFoodMythsEvening(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'food-myths-evening',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'bodySleeping'}>
            <span>🌙</span> {t('onboarding.foodMythsEvening.options.bodySleeping')}
          </Option>
          <Option value={'myth'}>
            <span>🍽️</span> {t('onboarding.foodMythsEvening.options.myth')}
          </Option>
        </Check>
      </div>
    </div>
  );
}

export default Page;
